module.exports = __webpack_public_path__ + "img/cailiao.a9946e8e.png";